import React, { useState } from "react";
import {
  Stack,
  Heading,
  Text,
  RadioGroup,
  Radio,
  TextLink,
  Alert,
} from "@origin-digital/ods-core";

const MEDICAL_COOLING_FORM_URL =
  "https://services.dffh.vic.gov.au/sites/default/files/2018-09/Medical-cooling-concession-form.pdf";

const MedicalCoolingFields: React.FC = () => {
  const [value, setValue] = useState<"yes" | "no" | "">("");

  return (
    <Stack space={["large", "xlarge"]}>
      <Heading variant="h4">Medical heating/cooling</Heading>
      <RadioGroup
        label="Do you have a medical condition that requires heating or cooling?"
        name="medicalCooling"
        value={value}
        onChange={(e) => setValue(e.target.value as "yes" | "no")}
      >
        <Radio id="medical-cooling-yes" label="Yes" value="yes" />
        <Radio id="medical-cooling-no" label="No" value="no" />
      </RadioGroup>
      {value === "yes" && (
        <Alert
          title="You may be eligible for the Medical Cooling Concession"
          id="medical-cooling-info"
        >
          <Stack space="medium">
            <Text>
              If you or someone at your property have a medical condition that
              makes it difficult to self-regulate body temperature, and you hold
              a valid Pensioner Concession Card, Health Care Card, or Department
              of Veterans' Affairs Gold Card, download and complete the{" "}
              <TextLink
                href={MEDICAL_COOLING_FORM_URL}
                target="_blank"
                domProps={{ rel: "noopener noreferrer" }}
              >
                Medical Cooling Concession form
              </TextLink>{" "}
              and return the completed form to us.
            </Text>
          </Stack>
        </Alert>
      )}
    </Stack>
  );
};

export default MedicalCoolingFields;
